import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute('/_protected/$tenantKey/settings')({
  // パートナーユーザーにはマスタを見せない（#5602）。URL を直接開いてもマスタ画面に入れない
  beforeLoad: ({ context: { auth } }) => {
    if (auth.user.type === USER_TYPE.PARTNER) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
  },
  meta: () => [{ title: MENU.MASTER_SETTINGS }]
})
